import React, {useContext, useEffect, useState} from 'react';
import { useNavigate, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import resourcesServices from '../services/resourcesServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

const Cedulas = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)
  const [cedulas, setCedulas] = useState([])
  const [header, setHeader] = useState([]);
  const [query, setQuery] = useState({
    query: ""
  });

  useEffect(() => {
    if(authInformation.autenticado === false){
      navigate(`/ingreso`);
    } else if( authInformation.autenticado === true && authInformation.rol === 'Notificador'){
      setRenderHTML(true)
      fetchCedulas()
    } else {
      setRenderHTML(false)
    }
  }, [authInformation]);


  const fetchCedulas = async (sortBy='', q='', page=1, otro='') => {
    try {
      const data = await resourcesServices.obtenerResources('cedulas', sortBy, q, page, otro);

      if (page === 1) {
        setCedulas(data.data);
      } else {
        setCedulas([...cedulas, ...data.data]);
      }

      setHeader(data.headers);

    } catch (error) {
      errorMessage(error)
    }
  };

  const obtenerPagina = async (page=1) => {
    fetchCedulas('', query, page, '')
  };

  const abrirCedula = (notificacion_id) => {
    navigate(`/cedulaForm/${notificacion_id}`);
  }

  return (
    <div>
      <h1>Cédulas <BotonVolver /></h1>
      {renderHTML && (
        <>
        <div className='mb-3 text-end'>
        <Link to="/cedulaForm" className="btn btn-danger ms-3 mb-0" >Crear</Link>
        </div>
        <div className="card">
          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              <table className="table align-items-center mb-0 table-hover">
                <thead>
                  <tr>
                    <th className="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Destinatario</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Caracter</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Expediente</th>
                    <th className="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Sector</th>
                  </tr>
                </thead>
                <tbody>
                  {cedulas.map((cedula, index) => {
                    return (
                      <tr className='' role="button"  onClick={()=>abrirCedula(cedula.id)} key={index}
                        >
                        <td>
                          {cedula.domicilio}
                        </td>
                        <td>
                          {cedula.caracter}
                        </td>
                        <td className="align-middle text-center text-sm">
                          {cedula.expediente}
                        </td>
                        <td className="align-middle">
                          {cedula.sector}
                        </td>
                      </tr>
                    )
                  })
                  }
                </tbody>
              </table>

              {
                header["total-pages"] !== header["current-page"] && (
                  <div className='p-3'>
                    <button onClick={()=>obtenerPagina(header["current-page"] + 1)} className='btn btn-success mt-3'>Ver más | {header["current-page"]} de {header["total-pages"]}</button>
                  </div>
                )
              }
            </div>
          </div>
        </div>

        </>
      )}
    </div>
  );
};

export default Cedulas;